"use client";

import React from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import paySuccessIcon from "../assets/icons/pay_success_icon.svg";
import { SecuredFooter } from "./ui/secured-footer";

const PaymentComplete = ({ onDone, transactionData }) => {
  const handleDone = () => {
    if (onDone) {
      onDone();
    }
  };
  return (
    <div className="bg-white rounded-2xl border border-[#EBE9EF] ">
      <Card className="w-full bg-white border-none !shadow-none relative">
        <CardContent className="px-6 py-12 w-full">
          <div className="flex flex-col items-center justify-center text-center min-h-[400px]">
            <div className="mb-8">
              <img
                src={paySuccessIcon}
                alt="Payment Success"
                width={194}
                height={136}
              />
            </div>
            <h1 className="text-[32px] font-semibold text-[#33125F] leading-[40px] mb-6">
              Done & Dusted.
            </h1>
            <p className="text-[20px] text-[#423E51] leading-[32px] max-w-[338px]">
              Payment sent. No need to lift another finger.
            </p>
          </div>
        </CardContent>
        <div className="flex justify-center w-full px-6 pb-8">
          <Button
            onClick={handleDone}
            className="py-3 px-16 h-[48px] w-[302px] text-[14px] font-semibold text-white rounded-full bg-[linear-gradient(70.19deg,#57249C_10.66%,#EB3366_113.47%)] hover:opacity-90"
          >
            Done
          </Button>
        </div>
      </Card>
      <SecuredFooter />
    </div>
  );
};

export default PaymentComplete;
